import Mustache from 'mustache';
export type TemplateProcessor = (template: string) => string


export const createTemplateProcessor = (templateContext: object): TemplateProcessor => {
  return (template: string) => {
    try {
      return Mustache.render(template, templateContext);
    } catch {
      return template;
    }
  };
};
